const HERO_DATA = {
  title: "Canuckz NFT", 
  tagline: "Get your Canuckz!", 
  blurb: "Some cool witty text that is sure to wow your potential customers."
}

export default HERO_DATA;